import '../css/module_subscribe.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';

import {
    funnelUpdateWhenAvailable, 
    freeTrialManage,
    updateBuyButtonCta,
    updateBuyButtonDescription,
    userIsLogged,
    userIsPremium,
    premiumSubscribeMsg,
    doSelectPlan,
    successNotification,
    ManageLoginWithListener,
    checkoutLink,
    showSpinner,
} from './module_common';

import {
    preCheckoutActions,
    reVerifyEmailAndOpenResendPopup,
} from './module_checkout_helper'

import './module_common_actions';

import { initNavbar } from './module_header';
import { reviewCarouselSetUp } from './module_landing_offer_common';

window.doSelectPlan = doSelectPlan;

const evaluateMarkerPosition = function(mark, target){
    if (window.innerWidth > 450) return;
    let threshold = mark.offset().top;
    let wh = window.innerHeight;
    let ws = $(window).scrollTop();
    let current = wh + ws;
    if ( current < threshold) {
        if (!target.hasClass('is-hidden')){
            target.addClass('is-hidden');
        }
    } else {
        if (target.hasClass('is-hidden')){
            target.removeClass('is-hidden');
        }
    }
}

const manageMarker = function(){
    if(!$('#action-marker-subscribe').length) return;
    const mark = $('#action-marker-subscribe');
    const target = $('.button-mobile.hidden');
    evaluateMarkerPosition(mark, target);
    $(window).scroll(function() {
        evaluateMarkerPosition(mark, target);
    });
}

function manageBuyButtonClick(){
    // Only premium, not-logged and logged-not-verified comes here.
    // Other user has an anchor element with link to checkout page, from php template.
    if (userIsLogged){
        if (userIsPremium){
            successNotification(premiumSubscribeMsg)
        }else{
            // not verified
            reVerifyEmailAndOpenResendPopup(selectedPlan)
        }
    }else{
        ManageLoginWithListener(handleUserLogin, {plan: selectedPlan}, handleEmailVerificationFlowDone)
    }
}

function handleUserLogin(e, data){
    const usrDetail = e.detail
    sessionStorage.setItem('mustReloadOnBack', location.href)
    showSpinner()
    if (usrDetail.verified){
        preCheckoutActions()
        const queryString = allPlans[data.plan]['chkQueryString']
        window.location.href = `${checkoutLink}${queryString}`
    }
    // not verified user is managed in handleEmailVerificationFlowDone
    // called after user close email-verification popup
}

function handleEmailVerificationFlowDone(){
    window.location.reload()
}

function attachBuyButtonClick(){
    $('.buy-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

function attachHeaderBuyButtonClick(){
    $('.header-subscribe-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

function attachToCheckoutButtonClick(){
    $(".to-chk-btn-ref").on('click', function(e){
        preCheckoutActions()
    })
}

$(function () {
    initFirebaseApp()
    manageLogin()
    
    doLast()
    initNavbar()
    const plan = allPlans[selectedPlan]
    freeTrialManage(plan.trialPeriod)
    updateBuyButtonCta(plan.label)
    updateBuyButtonDescription(plan.description)

    attachBuyButtonClick()
    attachHeaderBuyButtonClick()
    attachToCheckoutButtonClick()

    reviewCarouselSetUp()

    manageMarker()

    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('checkout_viewed');
});